var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application_case_banner"})
}
var staticRenderFns = []

export { render, staticRenderFns }